module.exports = __webpack_public_path__ + "static/media/girl-12.0296fe2b.svg";